'use strict';
import * as $i_$0040awesome$002eme$002fwebawesome$002fdist$002fcomponents$002fselect$002fselect$002ejs from "@awesome.me/webawesome/dist/components/select/select.js";
import * as $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024 from "./com.raquo.laminar.-Dom-Api$.js";
import * as $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024 from "./com.raquo.laminar.codecs.package$.js";
import * as $j_com$002eraquo$002elaminar$002ekeys$002e$002dEvent$002dProp from "./com.raquo.laminar.keys.-Event-Prop.js";
import * as $j_io$002egithub$002enguyenyou$002ewebawesome$002elaminar$002e$002dWeb$002dComponent from "./io.github.nguyenyou.webawesome.laminar.-Web-Component.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lio_github_nguyenyou_webawesome_laminar_Select$() {
  this.jN = null;
  this.jM = null;
  this.jO = false;
  this.jP = null;
  this.jQ = false;
  this.Iz = null;
  this.IA = false;
  this.IB = null;
  this.IC = false;
  $j_io$002egithub$002enguyenyou$002ewebawesome$002elaminar$002e$002dWeb$002dComponent.$ct_Lio_github_nguyenyou_webawesome_laminar_WebComponent__T__(this, "wa-select");
}
export { $c_Lio_github_nguyenyou_webawesome_laminar_Select$ as $c_Lio_github_nguyenyou_webawesome_laminar_Select$ };
$p = $c_Lio_github_nguyenyou_webawesome_laminar_Select$.prototype = new $j_io$002egithub$002enguyenyou$002ewebawesome$002elaminar$002e$002dWeb$002dComponent.$h_Lio_github_nguyenyou_webawesome_laminar_WebComponent();
$p.constructor = $c_Lio_github_nguyenyou_webawesome_laminar_Select$;
/** @constructor */
function $h_Lio_github_nguyenyou_webawesome_laminar_Select$() {
}
export { $h_Lio_github_nguyenyou_webawesome_laminar_Select$ as $h_Lio_github_nguyenyou_webawesome_laminar_Select$ };
$h_Lio_github_nguyenyou_webawesome_laminar_Select$.prototype = $p;
$p.jt = (function() {
  if ((!this.IA)) {
    this.Iz = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), new $j_com$002eraquo$002elaminar$002ekeys$002e$002dEvent$002dProp.$c_Lcom_raquo_laminar_keys_EventProp("change"));
    this.IA = true;
  }
  return this.Iz;
});
$p.uH = (function() {
  if ((!this.IC)) {
    this.IB = ($j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$m_Lcom_raquo_laminar_api_package$(), $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$ct_Lcom_raquo_laminar_keys_HtmlAttr__T__Lcom_raquo_laminar_codecs_Codec__(new $j_com$002eraquo$002elaminar$002e$002dDom$002dApi$0024.$c_Lcom_raquo_laminar_keys_HtmlAttr(), "value", $j_com$002eraquo$002elaminar$002ecodecs$002epackage$0024.$m_Lcom_raquo_laminar_codecs_package$().ci));
    this.IC = true;
  }
  return this.IB;
});
$p.cQ = (function() {
  return $i_$0040awesome$002eme$002fwebawesome$002fdist$002fcomponents$002fselect$002fselect$002ejs;
});
var $d_Lio_github_nguyenyou_webawesome_laminar_Select$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lio_github_nguyenyou_webawesome_laminar_Select$, "io.github.nguyenyou.webawesome.laminar.Select$", ({
  jS: 1,
  bp: 1,
  bo: 1,
  jW: 1
}));
export { $d_Lio_github_nguyenyou_webawesome_laminar_Select$ as $d_Lio_github_nguyenyou_webawesome_laminar_Select$ };
var $n_Lio_github_nguyenyou_webawesome_laminar_Select$;
function $m_Lio_github_nguyenyou_webawesome_laminar_Select$() {
  if ((!$n_Lio_github_nguyenyou_webawesome_laminar_Select$)) {
    $n_Lio_github_nguyenyou_webawesome_laminar_Select$ = new $c_Lio_github_nguyenyou_webawesome_laminar_Select$();
  }
  return $n_Lio_github_nguyenyou_webawesome_laminar_Select$;
}
export { $m_Lio_github_nguyenyou_webawesome_laminar_Select$ as $m_Lio_github_nguyenyou_webawesome_laminar_Select$ };
